const faqs = [
  {
    id: 1,
    question: '51吃瓜网站是什么？',
    answer: '51吃瓜网站是一个专注于娱乐八卦、明星动态、网红黑料与综艺内幕的聚合型资讯平台。我们通过51吃瓜网址入口，每日汇集全网最新最全的吃瓜视频与图文内容，提供51吃瓜网在线观看服务，是吃瓜群众的一站式吃瓜入口。',
  },
  {
    id: 2,
    question: '如何下载51吃瓜APP？',
    answer: '你可以在本页 #app 区域找到51吃瓜APP下载入口，目前支持iOS和Android双平台。下载安装后即可随时随地通过51吃瓜在线观看最新吃瓜视频，享受实时推送、离线缓存等专属移动端功能。',
  },
  {
    id: 3,
    question: '51吃瓜网站的内容更新频率是怎样的？',
    answer: '51吃瓜网站保持7×24小时全天候更新，编辑团队实时追踪微博、抖音、小红书等主流社交平台的最新动态。日均更新超过200条吃瓜内容，确保你每次打开51吃瓜入口都能看到最新的娱乐资讯和黑料视频。',
  },
  {
    id: 4,
    question: '51吃瓜网站安全吗？会不会有病毒或广告？',
    answer: '51吃瓜网站采用安全加密连接，所有51吃瓜网址入口均经过安全检测。我们承诺无弹窗广告、无恶意跳转、无诱导下载，为用户提供纯净安全的吃瓜浏览体验。请放心使用51吃瓜网在线观看服务。',
  },
  {
    id: 5,
    question: '如何向51吃瓜网站投稿或提供吃瓜线索？',
    answer: '欢迎通过 #contact 区域的联系方式向我们投稿。你可以发送邮件至 tips@51chigua.com 提供独家吃瓜线索或黑料素材。一经采用，我们将根据内容质量支付相应稿酬。你的个人信息将严格保密。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            关于51吃瓜网站的常见疑问，这里有你想知道的一切
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {faqs.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform duration-300"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}